import React, { useState, useEffect } from "react";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { headers } from "../../utils/utils";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
} from "@mui/material";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function CartManagement({
  cart,
  setCart,
  currency,
  productList,
}) {
  const [quantities, setQuantities] = useState([]);

  useEffect(() => {
    if (productList.length > 0) {
      setQuantities(Array(productList.length).fill(1)); // Reset quantities when productList updates
    }
  }, [productList]);

  const [open, setOpen] = useState(false); // Modal visibility

  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Track current image index
  const [selectedImage, setSelectedImage] = useState(""); // Selected image to show in modal
  const [zoomLevel, setZoomLevel] = useState(1); // Zoom level state
  const [selectedProduct, setSelectedProduct] = useState("");

  const handleQuantityChange = (index, event) => {
    const value = parseInt(event.target.value, 10) || 1; // Ensure a valid number and default to 1 if empty/invalid
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] = value;
      return newQuantities;
    });
  };

  const handleAddToCart = (index) => {
    const product = productList[index];
    const isInCart = cart.some((item) => item.id === product.id);

    if (isInCart) {
      setCart((prevCart) => prevCart.filter((item) => item.id !== product.id));
    } else {
      const cartItem = {
        ...product,
        quantity: quantities[index],
        image: product.imageList && product.imageList[0],
      };
      setCart((prevCart) => [...prevCart, cartItem]);
    }
  };
  const handleImageClick = (index, image, piIndex) => {
    setCurrentImageIndex(index);
    setSelectedProduct(productList[piIndex]);
    setSelectedImage(image);
    setZoomLevel(1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNextImage = () => {
    const nextIndex =
      (currentImageIndex + 1) % selectedProduct.imageList.length; // Go to next image
    setCurrentImageIndex(nextIndex);
    console.log("selectedProduct", selectedProduct);
    setSelectedImage(selectedProduct.imageList[nextIndex]);
  };

  const handlePrevImage = () => {
    const prevIndex =
      (currentImageIndex - 1 + selectedProduct.imageList.length) %
      selectedProduct.imageList.length; // Go to previous image
    setCurrentImageIndex(prevIndex);
    setSelectedImage(selectedProduct.imageList[prevIndex]);
  };

  const handleWheelZoom = (event) => {
    event.preventDefault(); // Prevent the default scroll behavior
    if (event.deltaY < 0) {
      // Scroll up -> zoom in
      setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3)); // Max zoom level: 3
    } else {
      // Scroll down -> zoom out
      setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 1)); // Min zoom level: 1
    }
  };

  return (
    <Box sx={{ flexGrow: 1, padding: 4 }}>
      <Grid container spacing={3}>
        {productList.length == 0 && <>No Items</>}
        {productList.map((product, index) => {
          const isInCart = cart.some((item) => item.id === product.id);
          return (
            <Grid item xs={12} sm={6} md={3} key={product.id}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  "&:hover": { transform: "scale(1.05)" },
                }}
              >
                <Carousel infiniteLoop showThumbs thumbWidth={50}>
                  {product.imageList && product.imageList.length > 0 ? (
                    product.imageList.map((image, idx) => (
                      <div
                        key={idx}
                        onClick={() => handleImageClick(idx, image, index)}
                      >
                        <img src={image} alt={`Image ${idx + 1}`} />
                      </div>
                    ))
                  ) : (
                    <>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                    </>
                  )}
                </Carousel>
                <CardContent>
                  <Typography variant="h6" fontWeight="bold">
                    {product.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {product.description}
                  </Typography>
                  <Typography variant="h5" color="primary" mt={2}>
                    {currency} {product.salePrice.toFixed(2)}
                  </Typography>
                  {!isInCart ? (
                    <Grid container spacing={2} alignItems="center" mt={2}>
                      <Grid item xs={4}>
                        <FormControl fullWidth variant="standard">
                          <InputLabel htmlFor={`quantity-${index}`}>
                            Quantity
                          </InputLabel>
                          <Input
                            id={`quantity-${index}`}
                            value={quantities[index]}
                            onChange={(event) =>
                              handleQuantityChange(index, event)
                            }
                            startAdornment={
                              <InputAdornment position="start">
                                <ShoppingCartIcon />
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={0.5}></Grid>
                      <Grid item xs={7}>
                        <br />
                        <Typography variant="subtitle2">
                          {" "}
                          x {currency} {product.salePrice.toFixed(2)} ={" "}
                          {currency}{" "}
                          {(quantities[index] * product.salePrice).toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <br />
                      <br />
                      <Typography variant="subtitle2">
                        {product.salePrice.toFixed(2)} X {currency}{" "}
                        {quantities[index]} = {currency} $
                        {(quantities[index] * product.salePrice).toFixed(2)}
                      </Typography>
                      <br />
                    </>
                  )}
                  <Button
                    variant="contained"
                    color={isInCart ? "error" : "success"}
                    fullWidth
                    startIcon={
                      isInCart ? (
                        <RemoveShoppingCartIcon />
                      ) : (
                        <ShoppingCartIcon />
                      )
                    }
                    onClick={() => handleAddToCart(index)}
                    sx={{
                      mt: 2,
                      padding: "12px",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      transition: "0.3s ease",
                      "&:hover": {
                        backgroundColor: isInCart ? "#d32f2f" : "#388e3c",
                      },
                    }}
                  >
                    {isInCart ? "Remove from Cart" : "Add to Cart"}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Image Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogContent
          onWheel={handleWheelZoom}
          sx={{ position: "relative", textAlign: "center" }}
        >
          {selectedImage ? (
            <img
              src={selectedImage}
              alt="Selected Product"
              style={{
                width: `${zoomLevel * 100}%`,
                height: "auto",
                transition: "transform 0.3s ease",
              }}
            />
          ) : (
            ""
          )}

          <Button
            onClick={handleNextImage}
            sx={{ position: "absolute", top: "50%", right: 16 }}
          >
            <ArrowForwardIosIcon />
          </Button>
          <Button
            onClick={handlePrevImage}
            sx={{ position: "absolute", top: "50%", left: 16 }}
          >
            <ArrowBackIosNewIcon />
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
